<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import Modal from "../../../../components/modals/modal-form.vue";
import api from '../../../../helpers/apirest/api';

import {
    identificationTypeMethods,
    identificationTypeComputed
} from "@/state/helpers";

const initialState = () => {
    return {
        submitted: false,
        customer: {
            identification_type_id: '',
            identification: '',
            first_name: '',
            last_name: '',
        }
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number
    },
    data() {
        return initialState();
    },
    components: {
        Modal
    },
    computed: {
        ...identificationTypeComputed
    },
    validations: {
        customer: {
            identification_type_id: { required },
            identification: { required, minLength: minLength(5), maxLength: maxLength(30) },
            first_name: { required },
            last_name: {  },
        }
    },
    methods: {
        ...identificationTypeMethods,
        async shown() {
            this.loadList();
            if (this.id) {
                const response = await api.get({
                    url: `customers/${this.id}`
                });
                this.customer = response?.data?.data;
            }
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const data = this.customer;

            await api.save({
                url: 'customers',
                id: this.customer?.id,
                data: data 
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess");
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        }
    }
};
</script>

<template>
    <Modal :title="'Custom title'" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal">
        <div class="form-group">
            <label for="identification_type_id">Identification Type</label>
            <select v-model="customer.identification_type_id" class="form-control"
                :class="{ 'is-invalid': $v.customer.identification_type_id.$error && submitted }">
                <option value="">Select</option>
                <option v-for="option in identificationTypes" v-bind:value="option.id" :key="option.id">
                    {{ option.prefix }} - {{ option.name }}
                </option>
            </select>
            <div v-if="!$v.customer.identification_type_id.required && submitted" class="invalid-feedback">Identification
                Type is
                required</div>
        </div>
        <div class="form-group">
            <label for="identification">Identification</label>
            <input id="identification" v-model="customer.identification" type="text" class="form-control"
                placeholder="Enter name" :class="{ 'is-invalid': $v.customer.identification.$error && submitted }" />
            <span v-if="!$v.customer.identification.required && submitted" class="invalid-feedback">Identification is
                required.</span>
            <span v-else-if="!$v.customer.identification.minLength && submitted" class="invalid-feedback">Min number of
                characters: {{
                    $v.customer.identification.$params.minLength.min }}.</span>
            <span v-else-if="!$v.customer.identification.maxLength && submitted" class="invalid-feedback">Max number of
                characters: {{
                    $v.customer.identification.$params.maxLength.max }}.</span>
        </div>
        <div class="form-group">
            <label for="name">Name</label>
            <input id="name" v-model="customer.first_name" type="text" class="form-control" placeholder="Enter name"
                :class="{ 'is-invalid': $v.customer.first_name.$error && submitted }" />
            <div v-if="!$v.customer.first_name.required && submitted" class="invalid-feedback">Name is required</div>
        </div>
        <div class="form-group">
            <label for="last_name">Last Name</label>
            <input id="last_name" v-model="customer.last_name" type="text" class="form-control" placeholder="Enter name"
                :class="{ 'is-invalid': $v.customer.last_name.$error && submitted }" />
            <div v-if="!$v.customer.last_name.required && submitted" class="invalid-feedback">Last Name is required</div>
    </div>
</Modal></template>